import React from "react";
import PublicLayout from "../../../layouts/user/PublicLayout";
import BeritaPopuler from "../../../components/user/posts/BeritaPopuler";
import CardKontak from "../../../components/user/kontak/CardKontak";

function Kontak() {
	return (
		<PublicLayout
			title="Kontak"
			subtitle="Hubungi kami untuk informasi lebih lanjut"
		>
			<div className="flex flex-col lg:flex-row gap-8">
				<div className="w-full lg:w-[68%]">
					<CardKontak />
				</div>
				<div className="w-full lg:w-[30%]">
					<BeritaPopuler />
				</div>
			</div>
		</PublicLayout>
	);
}

export default Kontak;
